import { render } from "./ComplexTable.vue?vue&type=template&id=41870090"
import script from "./ComplexTable.vue?vue&type=script&lang=ts"
export * from "./ComplexTable.vue?vue&type=script&lang=ts"
script.render = render

export default script